import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Config from '../../config';
import isAdBlock from 'blockadblock';

import {
  InitApplication,
  LocaleChange,
  SetSettingsState,
  OpenMessage,
  ShareRequestDone,
  OpenProfileFor,
  ShowToast,
  Reset,
  GetMetadataOnLogin
} from '../../actions/common/actions-common';

import { Me as NarMe } from '../../actions/_extentions/nar/actions-nar';

import * as Dictionaries from '../../locales';

import moment from 'moment';
import _isEqual from 'lodash/isEqual';
import _get from 'lodash/get';
import _size from 'lodash/size';
import _keys from 'lodash/keys';
import _forOwn from 'lodash/forOwn';
import counterpart from 'counterpart';
import Translate from '../../components/Translate/translate';
import {StubFunc, HasHash, SetLocaleForMoment} from '../../utils';

import EmbeddedProfile from '../../components/ShowcaseCollection/EmbeddedProfile';
import BannersSlider from '../BannersSlider';
import BgSlider from '../BgSlider';
import Player from '../Player';
import LoginForm from '../LoginForm';
import ModalWindow from '../ModalWindow';
import Toasts from '../Toasts';
import NavigationMenu from '../NavigationMenu';
import Settings from '../Settings';
import Footer from '../Footer';

class RootApp extends Component {
  constructor(props) {
    super(props);

    this.NotificationsTimeout = [];

    this.state = {
      isExtended: false,
      selectedAsset: null,
      shownShares: [],
      timestamp: moment().unix()
    };
  }

  componentWillMount() {

    let hostname = window.location.host + '/api';
    let protocol = window.location.protocol.replace(':', '');

    /**
     * Config for LH SDK
     */
    lh.common.config.set({
      endpoint: {
        hostname: hostname,
        protocol: protocol,
        timeout: 40000
      },
      devServer: false,
      loggingLevel: 'error',
      noCache: false
    });

    if (this.props.locales && this.props.locales.length) {
      for (let i = 0; i < this.props.locales.length; i++) {
        let loc = this.props.locales[i].value;

        if (Dictionaries[loc]) {
          counterpart.registerTranslations(loc, Dictionaries[loc]);
        }
      }
    }

    if (counterpart.getAvailableLocales().indexOf(this.props.locale) === -1) {
      console.warn('Locale from cookies not found');

      if (Dictionaries[_get(Config, 'def_locale', 'en_US')]) {
        counterpart.registerTranslations(_get(Config, 'def_locale', 'en_US'), Dictionaries[_get(Config, 'def_locale', 'en_US')]);
        counterpart.setLocale(_get(Config, 'def_locale', 'en_US'));

        SetLocaleForMoment(_get(Config, 'def_locale', 'en_US'));

        const langParse = _get(Config, 'def_locale', 'en_US').split('_');
        lh.common.config.set({'localizationLanguage': (langParse[0] || 'en').toUpperCase()});
      } else if (Dictionaries['en_US']) {
        counterpart.registerTranslations('en_US', Dictionaries['en_US']);
        counterpart.setLocale('en_US');

        SetLocaleForMoment('en_US');

        const langParse = 'en_US'.split('_');
        lh.common.config.set({'localizationLanguage': (langParse[0] || 'en').toUpperCase()});
      }
    } else {

      counterpart.setLocale(this.props.locale);

      SetLocaleForMoment(this.props.locale);

      const langParse = this.props.locale.split('_');
      lh.common.config.set({'localizationLanguage': (langParse[0] || 'en').toUpperCase()});
    }
  }

  componentDidMount() {

    if (HasHash.test(window.location.hash)) {

      let hashState = window.location.hash.replace(/^#\/?|\/$/g, '').split('/');

      if (hashState[0] === 'password' && hashState[1] === 'reset' && hashState[2]) {

        this.props.SetSettingsState({
          isShown: true,
          tabId: 'reset-password',
          meta: {
            ack: hashState[2]
          }
        });
      } else if (hashState[0] === 'activate' && hashState[1]) {

        this.props.SetSettingsState({
          isShown: true,
          tabId: 'registration-confirm',
          meta: {
            ack: hashState[1]
          }
        });
      }
    }

    this.props.InitApplication(this.props.user);

    if (_size(this.props.notifications)) {

      this._processNotifications(this.props.notifications);
    }

    if (_size(this.props.shares)) {

      this._processShareRequest(this.props.shares);
    }

    if (this.props.globalProfile && this.props.globalProfile !== 'embedded') {

      this._onClose();
    }

    if (!_get(navigator, 'cookieEnabled', false)) {

      this.props.ShowToast({
        type: 'cookies',
        message: '',
        operation: 'enable_cookies',
        isBlocked: true,
        isPulse: true
      });
    }

    // setTimeout(() => {
    //  blockAdBlock && blockAdBlock.on(true, () => {
    //
    //    this.props.ShowToast({
    //      type: 'adblock',
    //      message: '',
    //      operation: 'disable_adblock',
    //      isBlocked: true,
    //      isPulse: true
    //    });
    //  });
    // });
  }

  componentWillReceiveProps(newProps) {
    if (this.props.locale !== newProps.locale) {
      counterpart.setLocale(newProps.locale);
    }

    if (!_isEqual(newProps.notifications, this.props.notifications)) {

      this._processNotifications(newProps.notifications);
    }

    if (!_isEqual(newProps.shares, this.props.shares)) {

      this._processShareRequest(newProps.shares);
    }

    if (!_isEqual(this.props.user, newProps.user)) {
      this.props.GetMetadataOnLogin(newProps.user);
      //TODO: FIXME should be in ^
      if (newProps.user.user !== 'guest' && _get(Config, 'operator_ext_id') === 'nar') {
        this.props.NarMe();
      }
      this.props.Reset();
    }

    if (newProps.globalProfile && newProps.globalProfile !== 'embedded') {

      this._onClose();
    }
  }

  _processNotifications(notifications) {
    this.NotificationsTimeout.forEach((timeout) => {

      clearTimeout(timeout);
    });

    this.NotificationsTimeout = [];

    notifications.forEach((notification) => {
      let delay = notification.start - moment().unix();

      if (delay > 0) {
        this.NotificationsTimeout.push(setTimeout(()=> {

          this.props.OpenMessage({
            type: 'notification',
            notification_id: notification.id
          });
        }, delay * 1000 - 1000 * 60 * 5));
      }
    });
  }

  _processShareRequest(shares) {

    _forOwn(shares, (value, key) => {
      if (this.state.shownShares.indexOf(key) === -1) {

        setTimeout(()=> {

          this.props.OpenMessage({
            type: 'share-request',
            asset_id: value.asset_id,
            position: value.position,
            asset_type: value.type,
            title: value.title,
            onClose: () => {
              this.props.ShareRequestDone(value.asset_id);

            }
          });
        }, 150);
      }
    });

    this.setState({
      shownShares: _keys(shares)
    });
  }

  _onExtendProfile(asset) {

    this.setState({
      selectedAsset: {
        id: asset.id,
        type: asset.type,
        opt: asset.package_type
      },
      isExtended: true
    });

    this.props.OpenProfileFor('embedded');
  }

  _onClose() {

    this.setState({isExtended: false, selectedAsset: null});
  }

  render() {

    return (
      <div>
        {
          this.props.init.isInitPhase ?
            <div className="init-progress">
              {!this.props.init.initError ?
                <div>
                  <div className="crow no-gutter init-logo">
                    <img className="logo-while-loading" src={Config.logo.img_url} />
                  </div>
                  <div id="global-progress" className="ui inverted active progress">
                    <div className="bar" style={{transitionDuration: '600ms', width: this.props.init.initProgress + '%'}}>
                      <div className="progress"><b>{this.props.init.initProgress ? this.props.init.initProgress + '%' : ''}</b></div>
                    </div>
                    <div className="label"><Translate content="loading" /></div>
                  </div>
                </div>
                :
                <div className="global-error" id="global-error">
                  <Translate content="global_error" />
                </div>
              }
            </div>
            :
            <div>
              {!this.props.init.reInit && <Player />}
              <BgSlider showcaseLabel={Config.background_label} onAssetSelect={this._onExtendProfile.bind(this)} />
              <LoginForm />
              <div className="wrapper site-wrapper">
                <Settings />
                <NavigationMenu menu={[Config.menu, Config.tiled_menu]} />
                <BannersSlider showcaseLabel={Config.banners_label} onAssetSelect={this._onExtendProfile.bind(this)} />
                {!this.props.init.reInit && <div id="app-body">
                  {<EmbeddedProfile selectedAsset={this.state.selectedAsset} isExtended={this.state.isExtended} onClose={this._onClose.bind(this)} />}
                  {this.props.children}
                </div>}
                <Footer />
              </div>
              <ModalWindow />
              <Toasts />
            </div>
        }
      </div>
    );
  }

}

RootApp.propTypes = {
  children: PropTypes.object.isRequired,
  locales: PropTypes.arrayOf(PropTypes.object).isRequired,
  locale: PropTypes.string.isRequired,
  init: PropTypes.object.isRequired,
  InitApplication: PropTypes.func.isRequired
};

RootApp.defaultProps = {
  InitApplication: StubFunc.bind(this, 'InitApplication')
};

function mapStateToProps({common: {locales, locale, init, shares, profile}, auth: {user}, notifications: {notifications}}, ownProps) {

  return {
    globalProfile: profile,
    locale,
    locales,
    init,
    user,
    shares,
    notifications: _get(notifications, 'collection', [])
  }
}

function mapDispatchToProps(dispatch) {

  return bindActionCreators({InitApplication, NarMe, GetMetadataOnLogin, LocaleChange, SetSettingsState, OpenMessage, ShareRequestDone, OpenProfileFor, ShowToast, Reset}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RootApp);



// WEBPACK FOOTER //
// ./src/containers/RootApp/root-app.js